import { MONTH_MAPPING_KEY } from "../../components/real/data/formDataToRow";

export const getBudgetVsCrValue = (params, inPercent = false) => {
  const columns = params.api.getColumnState();

  // Get current fiscal year
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const fiscalYearKey = `${currentYear - 1}-${currentYear}`;

  // Find columns for actual data (R) in current fiscal year
  const realColumns = columns.filter(
    (col) =>
      col.colId.includes("month_mapping_by_fiscal_year") &&
      col.colId.includes(`|R.`) &&
      col.colId.includes(fiscalYearKey) &&
      !col.hide,
  );

  // Extract the months from real data columns and filter those with values > 0
  const availableMonths = realColumns
    .map((col) => {
      const parts = col.colId.split("|R.");
      return parts.length > 1 ? parseInt(parts[1], 10) : null;
    })
    .filter((month) => {
      if (month === null) return false;

      // Check if the month has a value > 0
      const monthKey = `${fiscalYearKey}|R`;
      const monthValue =
        params.data?.[MONTH_MAPPING_KEY]?.[monthKey]?.[month] || 0;
      return parseFloat(monthValue) > 0;
    });

  // Calculate total for actual data (only for available months)
  let realTotal = 0;
  availableMonths.forEach((month) => {
    const monthKey = `${fiscalYearKey}|R`;
    const monthValue =
      params.data?.[MONTH_MAPPING_KEY]?.[monthKey]?.[month] || 0;
    realTotal += parseFloat(monthValue);
  });

  // Calculate total for budget data (only for available months)
  let budgetTotal = 0;
  availableMonths.forEach((month) => {
    // Find the correct budget column for this month (may include version number)
    const budgetColumnPrefix = `month_mapping_by_fiscal_year.${fiscalYearKey}|B|`;
    const budgetColumn = columns.find(
      (col) =>
        col.colId.startsWith(budgetColumnPrefix) &&
        col.colId.endsWith(`.${month}`)
    );

    if (budgetColumn) {
      // Extract the actual version from the column ID
      const parts = budgetColumn.colId.split("|");
      if (parts.length >= 2) {
        const budgetVersion = parts[2].split(".")[0]; // 2.1 -> 2
        const monthKey = `${fiscalYearKey}|B|${budgetVersion}`;

        // Get the actual value from the data
        const monthValue =
          params.data?.[MONTH_MAPPING_KEY]?.[monthKey]?.[month] || 0;
        budgetTotal += parseFloat(monthValue);
      }
    }
  });
  // Calculate difference (budget - real)
  const difference = budgetTotal - realTotal;

  if (inPercent) {
  //  console.log("budgetTotal", budgetTotal, "difference", difference, "realTotal", realTotal);
  //  console.log("calcul", (difference / realTotal) * 100);
   
    return realTotal !== 0
      ? Math.round(((difference / realTotal) * 100)) + " %"
      : 0 + " %";
  }
  
  return difference;
};
